var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Icon } from '@chakra-ui/react';
import React from 'react';
var PlusIcon = function (props) { return (React.createElement(Icon, __assign({ fill: 'none', height: '100%', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.75', viewBox: '0 0 24 24', width: 'auto' }, props),
    React.createElement("path", { d: 'M0 0h24v24H0z', fill: 'none', stroke: 'none' }),
    React.createElement("path", { d: 'M12 5l0 14' }),
    React.createElement("path", { d: 'M5 12l14 0' }))); };
export default PlusIcon;
//# sourceMappingURL=PlusIcon.js.map